$(document).ready(function () {

  (function initStickyCalc() {
    var OFFSET = 10;
    var CALC_PADDING_V = 80;
    var HEADER_CHANGE_MIN_WIDTH = 1279;

    function getHeaderBottom() {
      var selectors = [
        'sticky-header',
        '#shopify-section-header header',
        '#shopify-section-header',
        '.site-header',
        '.header-wrapper',
        'header[role="banner"]',
        'header'
      ];
      for (var i = 0; i < selectors.length; i++) {
        var el = document.querySelector(selectors[i]);
        if (!el) continue;
        var rect = el.getBoundingClientRect();
        if (rect.height > 0) return Math.max(0, rect.bottom);
      }
      return 0;
    }

    function update() {
      if ($(window).width() <= 1279) return;

      var winWidth = $(window).width();
      var headerBottom = winWidth > HEADER_CHANGE_MIN_WIDTH ? getHeaderBottom() : 0;
      var topOffset = headerBottom + OFFSET;

      $('.height-calculator').each(function () {
        var $section = $(this);
        var $calc = $section.find('.height-calculator__calc');
        var $content = $section.find('.height-calculator__calc-content');

        if (!$calc.length || $calc.css('position') !== 'sticky') return;

        if (!$calc.data('hc-transition-set')) {
          $calc.css('transition', 'top 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94)');
          $content.css('transition', 'max-height 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94)');
          $calc.data('hc-transition-set', true);
        }

        $calc.css('top', topOffset + 'px');

        var $body = $section.find('.height-calculator__body');
        var bodyRect = $body.length ? $body[0].getBoundingClientRect() : $section[0].getBoundingClientRect();

        var bodyVisibleTop = Math.max(bodyRect.top, topOffset);
        var bodyVisibleBot = Math.min(bodyRect.bottom, window.innerHeight);
        var bodyVisibleH   = Math.max(0, bodyVisibleBot - bodyVisibleTop);

        var maxH = bodyVisibleH - CALC_PADDING_V;

        if (maxH > 80) {
          $content.css('max-height', maxH + 'px');
        }
      });
    }

    var headerUpdateTimer;
    $(window).on('scroll', function () {
      requestAnimationFrame(update);
    });
    $(window).on('resize', function () {
      requestAnimationFrame(update);
      clearTimeout(headerUpdateTimer);
      headerUpdateTimer = setTimeout(update, 350);
    });
    update();
    $(window).on('load', update);
    setTimeout(update, 100);
    setTimeout(update, 500);
  })();

  function calcSeated(h) {
    return {
      desk:    {
        min: Math.max(58, Math.round(h * 0.3772)),
        max: Math.max(63, Math.round(h * 0.4072))
      },
      chair:   { min: Math.round(h * 0.2395), max: Math.round(h * 0.2695) },
      monitor: { min: Math.round(h * 0.6946), max: Math.round(h * 0.7246) },
    };
  }

 function calcStanding(h) {
    return {
      desk:    {
        min: Math.min(127, Math.round(h * 0.6347)),
        max: Math.min(133, Math.round(h * 0.6647))
      },
      monitor: { min: Math.round(h * 0.9401), max: Math.round(h * 0.9701) },
    };
  }

  function fmt(item) {
    return item.min + '&ndash;' + item.max + ' <span class="hc-result__unit">cm</span>';
  }

  function updateWrapper($wrap, data) {
    $wrap.find('.height-calculator__result-desk-height .hc-result__value').html(fmt(data.desk));

    if (data.chair) {
      $wrap.find('.height-calculator__result-chair-height .hc-result__value').html(fmt(data.chair));
      $wrap.find('.hc-badge--chair .hc-badge__value').html(fmt(data.chair));
    }

    $wrap.find('.height-calculator__result-monitor-height .hc-result__value').html(fmt(data.monitor));
    $wrap.find('.hc-badge--desk .hc-badge__value').html(fmt(data.desk));
    $wrap.find('.hc-badge--monitor .hc-badge__value').html(fmt(data.monitor));
  }

  function clearWrapper($wrap) {
    $wrap.find('.hc-result__value, .hc-badge__value').html('&mdash;');
  }

  function getProductsByHeight(h) {
    if (h >= 145 && h <= 169) {
      return ['HomePro'];
    } else if (h >= 170 && h <= 195) {
      return ['HomePro', 'HomeOne', 'HomeMax'];
    } else if (h >= 196 && h <= 200) {
      return ['HomePro', 'HomeOne'];
    } else if (h >= 201 && h <= 205) {
      return ['HomePro'];
    }
    return [];
  }

  function updateShopBtn(h) {
    var products = getProductsByHeight(h);
    var $btn = $('a.height-calculator__result-btn');

    if (!$btn.length) return;

    var baseHref = $btn.data('original-href');
    if (!baseHref) {
      baseHref = $btn.attr('href');
      $btn.data('original-href', baseHref);
    }

    if (!products.length) {
      $btn.attr('href', baseHref);
      return;
    }

    var params = products.map(function (p) {
      return 'title=' + encodeURIComponent(p);
    }).join('&');

    var separator = baseHref.indexOf('?') > -1 ? '&' : '?';
    $btn.attr('href', baseHref + separator + params);
  }

  var currentMode = 'seated';

  $('.height-calculator__mode').on('click', function () {
    $('.height-calculator__mode').removeClass('active');
    $(this).addClass('active');
    currentMode = $(this).data('mode');
    calculate();
  });

  $('.height-calculator__input').on('input', calculate);

  function calculate() {
    var raw          = parseFloat($('.height-calculator__input').val());
    var $input       = $('.height-calculator__input');
    var $error       = $('.height-calculator__input-error');
    var $output      = $('.height-calculator__output');
    var $placeholder = $output.find('.height-calculator__output-placeholder');
    var $sitting     = $output.find('.height-calculator__result.sitting');
    var $standing    = $output.find('.height-calculator__result.standing');

    if (!raw) {
      $error.text('').hide();
      $input.removeClass('height-calculator__input--error');
      $output.removeClass('active');
      $placeholder.show();
      $sitting.hide();
      $standing.hide();
      clearWrapper($sitting);
      clearWrapper($standing);
      return;
    }

    var errorLow  = $input.data('error-low');
    var errorHigh = $input.data('error-high');

    if (raw < 145 || raw > 205) {
      $error.text(raw < 145 ? errorLow : errorHigh).show();
      $input.addClass('height-calculator__input--error');
      $output.removeClass('active');
      $placeholder.show();
      $sitting.hide();
      $standing.hide();
      clearWrapper($sitting);
      clearWrapper($standing);
      return;
    }

    $error.text('').hide();
    $input.removeClass('height-calculator__input--error');
    $output.addClass('active');
    $placeholder.hide();

    if (currentMode === 'seated') {
      $sitting.show();
      $standing.hide();
      updateWrapper($sitting, calcSeated(raw));
    } else {
      $standing.show();
      $sitting.hide();
      updateWrapper($standing, calcStanding(raw));
    }

    updateShopBtn(raw);
  }

});